<template>
  <div id="page-user-edit">
    <vs-alert color="danger" title="Teacher Not Found" :active.sync="user_not_found">
      <span>Teacher record with id: {{ $route.params.teacherId }} not found or not a valid teacher. </span>
      <span>
        <span>Check </span><router-link :to="{name:'teachers'}" class="text-inherit underline">All Teachers</router-link>
      </span>
    </vs-alert>

    <vx-card v-if="user_data">
      <div slot="no-body" class="tabs-container px-6 pt-6">
        <vs-tabs v-model="activeTab" class="tab-action-btn-fill-conatiner">
          <vs-tab label="Account" icon-pack="feather" icon="icon-user">
            <div class="tab-text">
              <user-edit-tab-account class="mt-4" :data="user_data" />
            </div>
          </vs-tab>
          <vs-tab label="Feedbacks" icon-pack="feather" icon="icon-star">
            <div class="tab-text">
              <user-feedback class="mt-4" :data="user_data" />
            </div>
          </vs-tab>
          <vs-tab label="Signature" icon-pack="feather" icon="icon-feather">
            <div class="tab-text">
              <user-signature class="mt-4" :data="user_data" />
            </div>
          </vs-tab>
        </vs-tabs>
      </div>
    </vx-card>
  </div>
</template>

<script>

import UserFeedback from "./UserFeedback.vue"
import UserSignature from "./UserSignature.vue"
import UserEditTabAccount from "./UserEditTabAccount.vue"
import moduleUserManagement from '@/store/user-management/moduleUserManagement.js'

export default {
  components: {
    UserEditTabAccount,
    UserSignature,
    UserFeedback,
  },
  data() {
    return {
      user_data: null,
      user_not_found: false,
      activeTab: 0,
    }
  },
  watch: {
    activeTab() {
      this.fetch_user_data(this.$route.params.teacherId)
    }
  },
  methods: {
    fetch_user_data(userId) {

      this.$store.dispatch("userManagement/fetchTeacher", userId)
        .then(res => { 
          if(res.data.role == "teacher"){
            this.user_data = res.data 
          }
          else this.user_not_found = true
        })
        .catch(err => {
          if(err.response.status === 404) {
            this.user_not_found = true
            return
          }
          console.error(err) })
    }
  },
  created() {
    // Register Module UserManagement Module
    if(!moduleUserManagement.isRegistered) {
      this.$store.registerModule('userManagement', moduleUserManagement)
      moduleUserManagement.isRegistered = true
    }
    this.fetch_user_data(this.$route.params.teacherId)
  }
}

</script>
